import { loadable } from '@conekta/cronos/dynamic';
import { useTranslation } from '@conekta/cronos/i18n';
import { CheckoutFrameContext } from 'app/context/CheckoutFrameContext';
import { PaymentMethodType } from 'app/util/constants';
import { IImage } from 'app/util/interface';
import classNames from 'classnames';
import { useContext, useRef, createElement } from 'react';

import { getBrandsLogos, hasCashInProvider } from './helpers';
import { IPaymentMethodItem } from './interface';

import './PaymentMethodMenuItem.scss';

const CashContainer = loadable(() => import('app/pages/frames/container/CashContainer'), {
  ssr: false,
  fallback: <></>,
});
const BankContainer = loadable(() => import('app/pages/frames/container/BankTransferContainer'), {
  ssr: false,
  fallback: <></>,
});
const CardContainer = loadable(() => import('app/pages/frames/container/CardContainer'), {
  ssr: false,
  fallback: <></>,
});
const BnplContainer = loadable(() => import('app/pages/frames/container/BnplContainer'), {
  ssr: false,
  fallback: <></>,
});

const PaymentMethods: Record<PaymentMethodType, any> = {
  [PaymentMethodType.Cash]: CashContainer,
  [PaymentMethodType.BankTransfer]: BankContainer,
  [PaymentMethodType.Card]: CardContainer,
  [PaymentMethodType.Bnpl]: BnplContainer,
};

export const PaymentMethodMenuItem = ({
  active,
  id = '',
  information,
  onClick,
  selected,
  disable,
  isOpen,
  methodName,
}: IPaymentMethodItem) => {
  const {
    checkoutRequest: { excludeCardNetworks = [], providers = [] },
  } = useContext(CheckoutFrameContext);
  const { t } = useTranslation();
  const tRoot = 'iFrame.checkout';

  const contentRef = useRef<HTMLDivElement>(null);

  const handleToggleAccordion = () => {
    onClick && !disable && onClick();
  };

  const isCashIn = id === PaymentMethodType.Cash && hasCashInProvider(providers);

  return (
    <>
      <div
        className={classNames('paymentMethodMenuItem', { active, selected, disable })}
        onClick={handleToggleAccordion}
      >
        <div className="paymentMethodMenuItem__textSection">{information}</div>
        <div className="paymentMethodMenuItem__logos">
          {!disable &&
            getBrandsLogos(id, providers, excludeCardNetworks).map((image: IImage, key: number) => (
              <img key={key} {...image} />
            ))}
          {isCashIn && <p className="more-chains">{t(`${tRoot}.additionalPartners`)}</p>}
        </div>
      </div>
      <div ref={contentRef} className={classNames('paymentMethodMenuItem__accordion-content', { hide: !isOpen })}>
        {createElement(PaymentMethods[methodName])}
      </div>
    </>
  );
};

export default PaymentMethodMenuItem;
